export const openPromotionalModal = (handleModalOpen: (values: string) => (values: void) => void): void => {
  const hasPromoModalBeenShown = window.localStorage.getItem('hasPromoModalBeenShown');
  if (hasPromoModalBeenShown !== 'true' || !hasPromoModalBeenShown) {
    setTimeout((): void => {
      handleModalOpen('parentbirthModal')();
    }, 3000);
  }
};
